import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { Timeline } from '../models/timeline.model';

// The seller dashboard's drill-down: one buyer's own timeline, read-only, chosen by ?timeline=.
export const GetBuyerTimeline = createAsyncThunk(
    'engagements/GetBuyerTimeline',
    async (
        { engagementId, timelineId }: { engagementId: number; timelineId: number },
        dispatch: any
    ): Promise<Timeline> => {
        const axios = dispatch.getState().core.axios;
        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/timelines/${timelineId}`
            );
            if (response.status !== 200) {
                throw new Error('Failed to fetch the buyer timeline');
            }
            return response.data;
        } catch (error) {
            createNotification('An error occurred while loading the buyer timeline.', 'error');
            throw error;
        }
    }
);
